var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control dsf_teas_assess mobile dsf_teas_learning" },
    [
      !_vm.error
        ? _c(
            "van-tabs",
            {
              model: {
                value: _vm.activeIndex,
                callback: function ($$v) {
                  _vm.activeIndex = $$v
                },
                expression: "activeIndex",
              },
            },
            _vm._l(_vm.tabs, function (it, index) {
              return _c(
                "van-tab",
                { key: it.kc_text, attrs: { title: it.kc_text, name: index } },
                [
                  _c(
                    "div",
                    { staticClass: "scroll-box" },
                    [
                      _c("IframePage", {
                        attrs: {
                          url: _vm.detailUrl,
                          classId: it.teas_jwgl_bjgl_id,
                          pkglId: it.teas_jwgl_pkgl_id,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }